import Vue from 'vue';
import {submitYiiForm} from "../../helpers/yii";

const initial = window.variables.notifications || {};
const fixedCount = window.variables.fixedNotificationCount;

const countTotal = groups => Object.values(groups).map(type => type.count).reduce((a, b) => a + b, 0);

const isEmpty = groups => Object.keys(groups).length === 0;

export default {
    groups: initial,
    total: fixedCount + countTotal(initial),
    isEmpty: isEmpty(initial),

    async dismiss(item, type) {
        if (!this.groups[type]) {
            return;
        }

        const position = this.groups[type].items.indexOf(item);
        if (position === -1) {
            return;
        }

        // Eager update
        this.groups[type].items.splice(position, 1);
        this.groups[type].count -= 1;
        if (this.groups[type].count <= 0) {
            Vue.delete(this.groups, type);
        }
        this.total = fixedCount + countTotal(this.groups);
        this.isEmpty = isEmpty(this.groups);

        // Server-side update
        await submitYiiForm(item.links.dismiss);
    },

    async dismissAll(type) {
        if (!this.groups[type]) {
            return;
        }

        const dismissUrl = this.groups[type].links.dismiss;

        // Eager update
        Vue.delete(this.groups, type);
        this.total = countTotal(this.groups);
        this.isEmpty = isEmpty(this.groups);

        // Server-side update
        const response = await submitYiiForm(dismissUrl);
        if (response.data.success && response.data.data.hasOwnProperty(type)) {
            this.groups[type] = response.data.data[type];
            this.total = countTotal(this.groups);
            this.isEmpty = isEmpty(this.groups);
        }
    }
};
